import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  APP_WINDOW_QUERY_PARAM,
  APP_WINDOW_QUERY_VALUE,
  isInAppWindow,
  withAppWindowQuery,
} from "../../utils/appWindowUtils";

/*
 * While this SPA is the App Window overlay, keep ?appWindow=1 on every
 * client-side navigation so a refresh stays fullscreen until Shopify's
 * exit control closes the overlay.
 *
 * Example: history.push("/ui/settings?goto=1")
 *       →  "/ui/settings?goto=1&appWindow=1"
 */
const PreserveAppWindowQuery = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (!isInAppWindow()) {
      return;
    }
    const params = new URLSearchParams(location.search);
    if (params.get(APP_WINDOW_QUERY_PARAM) === APP_WINDOW_QUERY_VALUE) {
      return;
    }
    history.replace({
      pathname: location.pathname,
      search: `?${withAppWindowQuery(location.search)}`,
      hash: location.hash,
      state: location.state,
    });
  }, [
    history,
    location.hash,
    location.pathname,
    location.search,
    location.state,
  ]);

  return null;
};

export default PreserveAppWindowQuery;
